/**
 * AdditionalTab — extracted from EmployeeCreate.js.
 * Receives state + handlers via `ctx` prop bag.
 */
import React from 'react';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';
import { Button } from '../../../../components/ui/button';
import { Checkbox } from '../../../../components/ui/checkbox';
import { Textarea } from '../../../../components/ui/textarea';
import { TabsContent } from '../../../../components/ui/tabs';
import { Badge } from '../../../../components/ui/badge';
import { Plus, Trash2, User, Building2, Briefcase, Mail, Phone, Home, CreditCard, FileText, GraduationCap, Clock, DollarSign, Users, Heart, Calendar, Wallet, RefreshCw } from 'lucide-react';

const AdditionalTab = ({ ctx }) => {
  const {
    formData,
    handleAddAdditionalPayment,
    handleAdditionalPaymentChange,
    handleRemoveAdditionalPayment,
  } = ctx;

  return (
          <TabsContent value="additional">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Plus className="w-5 h-5 text-stone-700" />
                    Additional Payments (Infotype 0015)
                  </div>
                  <Button type="button" variant="outline" size="sm" onClick={handleAddAdditionalPayment}>
                    <Plus className="w-4 h-4 mr-1" /> Add Payment
                  </Button>
                </CardTitle>
              </CardHeader>
              <CardContent>
                {formData.additional_payments.length === 0 ? (
                  <div className="text-center py-8 text-gray-500">
                    <Plus className="w-12 h-12 mx-auto mb-3 text-gray-300" />
                    <p>No additional payments added yet.</p>
                    <p className="text-sm">Click "Add Payment" to add one-time bonuses, awards, etc.</p>
                  </div>
                ) : (
                  <div className="space-y-6">
                    {formData.additional_payments.map((payment, index) => (
                      <div key={payment._uid} className="border rounded-lg p-4 bg-gray-50">
                        <div className="flex justify-between items-center mb-4">
                          <h4 className="font-medium text-gray-700">Additional Payment #{index + 1}</h4>
                          <Button
                            type="button"
                            variant="ghost"
                            size="sm"
                            onClick={() => handleRemoveAdditionalPayment(payment._uid)}
                            className="text-red-500 hover:text-red-700"
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </div>
                        <div className="grid grid-cols-3 gap-4">
                          <div>
                            <Label>Wage Type Code *</Label>
                            <Input
                              value={payment.wage_type}
                              onChange={(e) => handleAdditionalPaymentChange(payment._uid, 'wage_type', e.target.value)}
                              placeholder="e.g., 2001, BON01"
                            />
                          </div>
                          <div>
                            <Label>Description</Label>
                            <Input
                              value={payment.wage_type_name || ''}
                              onChange={(e) => handleAdditionalPaymentChange(payment._uid, 'wage_type_name', e.target.value)}
                              placeholder="e.g., Performance Bonus"
                            />
                          </div>
                          <div>
                            <Label>Amount *</Label>
                            <Input
                              type="number"
                              value={payment.amount}
                              onChange={(e) => handleAdditionalPaymentChange(payment._uid, 'amount', e.target.value ? parseFloat(e.target.value) : '')}
                              placeholder="25000"
                            />
                          </div>
                          <div>
                            <Label>Currency</Label>
                            <select
                              value={payment.currency}
                              onChange={(e) => handleAdditionalPaymentChange(payment._uid, 'currency', e.target.value)}
                              className="w-full h-10 px-3 border rounded-md"
                            >
                              <option value="INR">INR</option>
                              <option value="USD">USD</option>
                              <option value="EUR">EUR</option>
                              <option value="GBP">GBP</option>
                            </select>
                          </div>
                          <div>
                            <Label>Payment Date *</Label>
                            <Input
                              type="date"
                              value={payment.payment_date}
                              onChange={(e) => handleAdditionalPaymentChange(payment._uid, 'payment_date', e.target.value)}
                            />
                          </div>
                          <div>
                            <Label>Reason</Label>
                            <Input
                              value={payment.payment_reason || ''}
                              onChange={(e) => handleAdditionalPaymentChange(payment._uid, 'payment_reason', e.target.value)}
                              placeholder="e.g., Annual Bonus, Award"
                            />
                          </div>
                          <div className="col-span-2">
                            <Label>Remarks</Label>
                            <Input
                              value={payment.remarks || ''}
                              onChange={(e) => handleAdditionalPaymentChange(payment._uid, 'remarks', e.target.value)}
                              placeholder="Additional notes..."
                            />
                          </div>
                          <div className="flex items-center">
                            <label className="flex items-center gap-2 cursor-pointer mt-6">
                              <input
                                type="checkbox"
                                checked={payment.is_taxable}
                                onChange={(e) => handleAdditionalPaymentChange(payment._uid, 'is_taxable', e.target.checked)}
                                className="w-4 h-4"
                              />
                              <span className="text-sm">Is Taxable</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
          </TabsContent>
  );
};

export default AdditionalTab;
